module.exports = __webpack_public_path__ + "static/media/subscribeBG.48d5c0d0.png";